import { render, staticRenderFns } from "./modal-mall-label.vue?vue&type=template&id=37eccf84&"
import script from "./modal-mall-label.vue?vue&type=script&lang=js&"
export * from "./modal-mall-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports